import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row } from 'antd';
import {
  SectionContent,
  TitleContainer,
  CategoryLabel,
  StyledSelect,
  ButtonContainer
} from './styled';
import { PLACEHOLDER_SELECT } from '../../constants/cmConstants';
import { getCategoryLabel } from '../../common/utils';

const CategorySelection = ({
  selectedValues,
  categoriesList,
  onProceedClick
}) => {
  const [selectedCategories, setSelectedCategories] = useState({});
  const [proceedClicked, setProceedClicked] = useState(false);

  useEffect(() => {
    setSelectedCategories(selectedValues);
  }, [selectedValues]);

  // Prepare category options, it should not contain selected value of other categories
  const getCategoryOptions = useCallback(
    (omitCategory1, omitCategory2) => {
      return categoriesList
        .filter(
          ({ displayName }) =>
            displayName !== selectedCategories?.[omitCategory1] &&
            displayName !== selectedCategories?.[omitCategory2]
        )
        ?.map(({ displayName }) => ({
          label: getCategoryLabel(displayName),
          value: displayName
        }));
    },
    [categoriesList, selectedCategories]
  );

  const onCategoryChange = (value) => {
    setProceedClicked(false);
    setSelectedCategories((values) => ({
      ...values,
      ...value
    }));
  };

  const onProceed = () => {
    setProceedClicked(true);
    onProceedClick(selectedCategories);
  };

  return (
    <>
      <TitleContainer>
        <div className="section-no">1</div>
        <div>Select Categories</div>
      </TitleContainer>
      <SectionContent>
        <Row gutter={32}>
          <Col span={8}>
            <CategoryLabel>Category 01</CategoryLabel>
            <StyledSelect
              options={getCategoryOptions('category2', 'category3')}
              onChange={(value) => onCategoryChange({ category1: value })}
              placeholder={PLACEHOLDER_SELECT}
              value={selectedCategories?.category1}
            />
          </Col>
          <Col span={8}>
            <CategoryLabel>Category 02</CategoryLabel>
            <StyledSelect
              allowClear
              disabled={!selectedCategories?.category1}
              options={getCategoryOptions('category1', 'category3')}
              onChange={(value) =>
                // Clear the category 3 value when the category 2 is cleared.
                onCategoryChange({
                  category2: value ?? selectedCategories?.category3,
                  ...(!value && { category3: undefined })
                })
              }
              placeholder={PLACEHOLDER_SELECT}
              value={selectedCategories?.category2}
            />
          </Col>
          <Col span={8}>
            <CategoryLabel>Category 03</CategoryLabel>
            <StyledSelect
              allowClear
              disabled={!selectedCategories?.category2}
              options={getCategoryOptions('category1', 'category2')}
              onChange={(value) => onCategoryChange({ category3: value })}
              placeholder={PLACEHOLDER_SELECT}
              value={selectedCategories?.category3}
            />
          </Col>
        </Row>
        <ButtonContainer className="segment-button-color">
          <Button
            type="primary"
            disabled={!selectedCategories?.category1 || proceedClicked}
            onClick={onProceed}>
            Proceed
          </Button>
        </ButtonContainer>
      </SectionContent>
    </>
  );
};

CategorySelection.propTypes = {
  selectedValues: PropTypes.object,
  categoriesList: PropTypes.array,
  onProceedClick: PropTypes.func.isRequired
};

export default CategorySelection;
